import { useDispatch, useSelector } from 'react-redux';
import { selectContactSupportFormOpen, setContactSupportFormOpen, } from '../../redux/slicers/appSlicer';
import { HubspotFormModal } from '../HubspotFormModal';

export const ContactSupportForm = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectContactSupportFormOpen);

  return (
    <HubspotFormModal
      title="Support"
      portalId="6917454"
      formId="76fd8c40-ed8b-46c8-9492-61f50ad4b896"
      open={open}
      onClose={() => dispatch(setContactSupportFormOpen(false))}
    />
  );
};
